<div class="floating-label">
    <input [formControlName]="controlName" [id]="inputId" type="hidden" autocomplete="off" />
    <field-error-display-control [displayError]="parentFormHelper.showFieldError(controlName)" [errorMsg]="parentFormHelper.getErrorMessageHtml(controlName)"> </field-error-display-control>
</div>
